// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightMiniReport-cls1_F75","cls2":"CiterightMiniReport-cls2_foH CiterightMiniReport-cls1_F75"};